/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../basicEmailMarketing.module.ts" />

module Meevo.Plugins.BasicEmailMarketing {

    import PackageType = Meevo.Model.PackageType;

    class PackageComponent implements ng.IComponentController {
        static $inject = [
            '$scope',
            '$translate',
        ];

        //#region bindings
        public model: PackageType;
        public onChange: () => {};
        public disabled: boolean;
        public hasEmpty: boolean;
        public initAsEmpty: boolean;
        public includeInactivePackage: boolean;
        //#endregion bindings

        public criteria;

        private anyPackage: PackageType;

        public anyActivePackage: PackageType = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_ACTIVE_PACKAGE')
        }

        constructor(
            protected $scope: ng.IScope,
            protected $translate: ng.translate.ITranslateService
        ) {
            this.setWatchers();
            this.criteria = {};
        }

        $onInit(): void {
            this.anyPackage = {
                id: null,
                displayName: this.$translate.instant('LABEL_ANY_PACKAGE')
            };

            if (this.initAsEmpty && (angular.isUndefined(this.model) || this.model === null)) {
                this.model = {...this.anyPackage};
            }
        }

        public typeAheadPreProcessData(responseData: PackageType[], requestData, includeInactive: boolean): PackageType[] {
            if (requestData.pageNumber === 0 && this.hasEmpty) {
                responseData.splice(0, 0, includeInactive ? this.anyPackage : this.anyActivePackage);
            }

            return responseData;
        }

        private setWatchers(): void {
            this.$scope.$watch(() => this.includeInactivePackage, () => {
                this.criteria = { includeInactive: this.includeInactivePackage }
                this.model = this.includeInactivePackage ? this.anyPackage : this.anyActivePackage;
            });
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .component('meevoClientSelectionPackage', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/basicEmailMarketing/components/package/package.template.html',
            controller: PackageComponent,
            controllerAs: '$ctrl',
            bindings: {
                model: '=ngModel',
                hasEmpty: '=',
                initAsEmpty: '=',
                onChange: '&',
                disabled: '=?ngDisabled',
                includeInactivePackage: '='
            }
        });
}
